// lingland-frontend/src/pages/BlogPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { blogPostsData } from './BlogPageData';
import { BlogPostCard } from './BlogPostCard';
import './BlogPage.css';

function BlogPage() {
    const { t } = useTranslation(['translation', 'blog']);
    const [headerRef, isHeaderVisible] = useIntersectionObserver();
    const [postsRef, isPostsVisible] = useIntersectionObserver();

    return (
        <>
            <SEO
                title={t('page_title', { ns: 'blog' })}
                description={t('page_subtitle', { ns: 'blog' })}
                url="/blog"
            />
            <section ref={headerRef} className={`page-header-section section-bg-white animate-on-scroll ${isHeaderVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>{t('page_title', { ns: 'blog' })}</h1>
                    <p className="subtitle">{t('page_subtitle', { ns: 'blog' })}</p>
                </div>
            </section>

            <section className={`blog-list-section section-bg-light-gray`}>
                 <div className="container">
                    <div
                        ref={postsRef}
                        className={`blog-grid blog-page-grid animate-on-scroll ${isPostsVisible ? 'is-visible' : ''}`}
                    >
                        {blogPostsData.map((post) => (
                            <BlogPostCard key={post.id} post={post} />
                        ))}
                    </div>
                 </div>
            </section>
        </>
    );
}

export default BlogPage;